import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { UseMutationOptions } from '@tanstack/react-query/src/types';

import { useApplicationContext } from 'shared/context/ApplicationContext';
import { EEntityType } from 'shared/repositories/favorites/entities/add_favorite/AddFavoriteEntityPublicRequestSchema';
import { IAddFavoriteRequest, IAddFavoriteResponse } from 'shared/repositories/favorites/v1/add-favorite';

import { QueryError, getQueryKey } from './internal/config';
import { fetchAddFavoriteService } from './internal/fetchService';

type AddFavoriteParameters = Omit<IAddFavoriteRequest, 'entityType'>;

export function useAddFavoriteMutation<TContext = unknown>(
  options?: Omit<
    UseMutationOptions<IAddFavoriteResponse, QueryError, AddFavoriteParameters, TContext>,
    'mutationKey' | 'mutationFn'
  >,
): UseMutationResult<IAddFavoriteResponse, QueryError, AddFavoriteParameters, TContext> {
  const context = useApplicationContext();

  return useMutation<IAddFavoriteResponse, QueryError, AddFavoriteParameters, TContext>({
    mutationFn: parameters =>
      fetchAddFavoriteService(context, { entityType: EEntityType.OfferCommercial, ...parameters }),
    mutationKey: getQueryKey(),
    ...options,
  });
}
